/**
 * Trailblazers sabotage artwork — one icon per sabotage type.
 *
 * The sabotage registry itself lives in `@swtorbit/shared-socket-events`
 * (`TRL_SABOTAGE_DEFINITIONS`), which the Node API server imports, so it can
 * carry no image imports. This module is the visual half of that registry: every
 * client surface that names a sabotage — the lobby picker, the map's placement
 * badge, the in-game notification, the treasure-theft reveal, and the admin
 * sabotage log / team cards / settings — resolves its glyph here.
 *
 * `TrlSabotageType` is imported as a TYPE ONLY, so this stays a pure asset module
 * with no runtime dependency, while the `Record` still fails to compile the
 * moment a sabotage type is added without artwork.
 *
 * The emoji on each definition remains the non-visual fallback (server log
 * lines, and any surface not converted to artwork).
 *
 * To add a type: drop the webp in `served/trl/sabotage/`, run
 * `npm run publish:art`, and add one {@link TRL_SABOTAGE_ICONS} entry.
 */
import { artUrl } from './art';
/**
 * Artwork for every sabotage type. Authored at 512px square with a transparent
 * background — always size it down in CSS at the point of use rather than
 * rendering it at source resolution.
 *
 * Exhaustive: a new sabotage type without artwork does not compile.
 */
export const TRL_SABOTAGE_ICONS = {
    treasure_thief: 'trl/sabotage/treasure_thief.webp',
    con_clue: 'trl/sabotage/con_clue.webp',
    scanner_spy: 'trl/sabotage/scanner_spy.webp',
};
/**
 * The icon for a sabotage type, or `''` for an unknown/absent one so a caller can
 * fall back without guarding first (an `<img src="">` renders nothing).
 */
export function getTrlSabotageIconUrl(type) {
    if (!type)
        return '';
    const asset = TRL_SABOTAGE_ICONS[type];
    return asset ? artUrl(asset) : '';
}
